import API from "../api/apiUser";

/**
 * Service for handling newsletter subscriptions for public users.
 */
export const UserSubscribersService = {
    /**
     * Public signup for newsletter
     * @param {string} email 
     */
    signup: async (email) => {
        try {
            const response = await API.post("/user/subscribers/signup", { email });
            return response.data;
        } catch (error) {
            console.error("Error signing up for newsletter:", error);
            throw error;
        }
    }
};
